<dx-popup
  [(visible)]="visible"
  [dragEnabled]="false"
  [height]="500"
  [hideOnOutsideClick]="true"
  [showCloseButton]="true"
  [showTitle]="true"
  [title]="editMode ? ('Katalog-Container ändern' | translate) : ('Katalog-Container anlegen' | translate)"
  [width]="700"
  contentTemplate="popupContent">
  <dxi-popup-toolbar-item
    [options]="{ stylingMode: 'outlined', text: ('Abbrechen' | translate), type:'normal', icon:'close', onClick: onCancel }"
    location="after"
    toolbar="bottom"
    widget="dxButton"/>
  <dxi-popup-toolbar-item
    [options]="{ stylingMode: 'outlined', text: ('Speichern' | translate), type:'default', icon:'save', onClick: onSave }"
    location="after"
    toolbar="bottom"
    widget="dxButton"/>
  <dxi-popup-toolbar-item [options]="{
                            stylingMode: 'outlined', 
                            icon : fullScreen ? 'collapse' : 'fullscreen',
                            hint: fullScreen ? 'Minimize' : 'Maximize',
                            onClick: toggleFullScreen
                          }"
                          location="after"
                          toolbar="top"
                          widget="dxButton">
  </dxi-popup-toolbar-item>

  <div *dxTemplate="let data of 'popupContent'">
    <div class="p-2">
      <div class="dx-field">
        <div class="dx-field-label">{{ 'Name' | translate }}</div>
        <div class="dx-field-value">
          <dx-text-box [(value)]="container.name"/>
        </div>
      </div>
      <div class="dx-field">
        <div class="dx-field-label">{{ 'Lieferant' | translate }}</div>
        <div class="dx-field-value" style="display: flex;flex-direction: row;align-items: center;">
          <dx-select-box [(value)]="container.dataSourceId"
                         [items]="suppliers"
                         displayExpr="name"
                         style="flex-grow: 1;"
                         valueExpr="id"/>
          <dx-button (onClick)="showEditOfSupplier()" *ngIf="container.dataSourceId" icon="edit"></dx-button>
          <dx-button (onClick)="showCreationOfSupplier()" icon="plus"></dx-button>
        </div>
      </div>
      <div class="dx-field">
        <div class="dx-field-label">{{ 'Notiz' | translate }}</div>
        <div class="dx-field-value">
          <dx-text-box [(value)]="container.note"/>
        </div>
      </div>
      <div class="dx-field">
        <div class="dx-field-label">{{ 'Logo' | translate }}</div>
        <div class="dx-field-value">
          <dx-file-uploader (onBeforeSend)="onBeforeSendUpload($event)"
                            (onUploaded)="onUploaded($event)"
                            accept="image/*"
                            uploadUrl="api/ImportContainer/UploadLogo"/>
        </div>
      </div>
    </div>

  </div>
</dx-popup>
<np-edit-datasource (saved)="onSupplierSaved($event)"
                    [(visible)]="supplierEditVisible"
                    [dataSource]="selectedSupplier"
                    [editMode]="supplierEditMode"/>
